import { Nullable } from "@shared/models/general";

export interface InsightsHubArticlesListResponse {
  data: Array<InsightsHubArticleResponseDto>;
  meta: {
    pagination: {
      page: number;
      pageCount: number;
      pageSize: number;
      total: number;
    };
  };
}

export interface InsightsHubArticleResponseAttributes {
  Author_Name: Nullable<string>;
  Author_Title: Nullable<string>;
  Author_Name2: Nullable<string>;
  Author_Title2: Nullable<string>;
  Author_Name3: Nullable<string>;
  Author_Title3: Nullable<string>;
  ShortDescription: Nullable<string>;
  Contact_Email: Nullable<string>;
  Content: Nullable<string>;
  createdAt: string;
  publishedAt: string;
  Publised_Date: Nullable<string>;
  Content_Type: Nullable<string>;
  Business_Segment_Type: string[];
  Title: Nullable<string>;
  Article_Type: Nullable<string>;
  Featured_Article: Nullable<boolean>;
  updatedAt: string;
  Content_Image?: StrapiMediaResponse | null;
  Homepage_Image?: StrapiMediaResponse | null;
}

export interface InsightsHubArticleResponseV4 {
  id: number;
  attributes: InsightsHubArticleResponseAttributes;
}

export interface InsightsHubArticleResponseV5 extends InsightsHubArticleResponseAttributes {
  id: number;
  documentId?: string;
}

export type InsightsHubArticleResponseDto = InsightsHubArticleResponseV4 | InsightsHubArticleResponseV5;

export const isInsightsHubArticleV4 = (
  article: InsightsHubArticleResponseDto
): article is InsightsHubArticleResponseV4 => "attributes" in article && article.attributes != null;

type StrapiMediaResponse = {
  url?: string;
  data?: {
    attributes?: {
      url: string;
      [prop: string]: unknown;
    };
    [prop: string]: unknown;
  };
  [prop: string]: unknown;
};
